import { urlFormatter } from "sb-resp-utils";
export const mapLeagueUrl = (ajustPath, league) => {
    const urlParams = `${urlFormatter.getSportUrl(league.sportName)}/${urlFormatter.getLeagueUrl(league.name)}`;
    league.linkUrl = ajustPath(urlParams);
    return league;
};
//# sourceMappingURL=mapLeagueUrl.js.map